import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import images from "assets/images";
import { contactRoute } from "constants/routes";
import get from "lodash/get";

import { PlatformSelector, SEO } from "components";

import { getPage } from "actions/page/page.functions";
import ModalVideo from 'react-modal-video';

class Index extends PureComponent {
  state = {
    platform: undefined,
    isModalOpen: false
  };

  componentDidMount() {
    const { dispatch } = this.props;

    let slug = "home";
    dispatch(getPage(slug));
  }
  openModal = () => { 
    this.setState({ isModalOpen: true});
  }

  closeModal = () => { 
    this.setState({ isModalOpen: false});
  }
  handleUpdatePlatform = event => {
    const { platform } =
      event.currentTarget.dataset || event.srcElement.dataset;

    this.setState({ platform });
  };

  render() {
    const { platform, isModalOpen } = this.state;
    const { singlePage } = this.props;

    const platformSelectorProps = {
      platform,
      updatePlatformCallback: this.handleUpdatePlatform
    };

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    return (
      <main className="view-index">
        <SEO {...seoProps} />
        <section className="hero">
          <div className="wrapper">
            <div className="hero__layout">
              <div className="hero__visual">
                <img alt="Homepage" src={images.illustrationHomeHero} />
                <button className="btn btn--play" onClick={this.openModal}><span className="btn--play__arrow" /></button>
              </div>
              <div className="hero__content">
                <h1 className="hero__title u-type--primary u-type--gamma u-spc-bottom--xlrg">
                  Communications beyond limits
                </h1>
                <p className="hero__subtitle u-type--epsilon u-type--o50 u-spc-bottom--lrg">
                  Your private network for safe messaging, voice and video
                  calling.
                </p>
                <PlatformSelector {...platformSelectorProps} />
              </div>
            </div>
          </div>
          <ModalVideo channel='vimeo' videoId='292154715' isOpen={isModalOpen} onClose={this.closeModal} />
        </section>
        <section className="section section--primary section--dark view-index__privacy">
          <div className="wrapper">
            <div className="view-index__privacy__layout">
              <div className="view-index__privacy__layout__visual">
                <img alt="Privacy" src={images.illustrationHomePrivacy} />
              </div>
              <div className="view-index__privacy__layout__content">
                <h3 className="u-type--gamma u-type--negative u-spc-bottom--xlrg">
                  Privacy without compromise
                </h3>
                <p className="u-type--zeta u-type--o50 u-type--negative u-spc-bottom--lrg">
                  Encryption mechanisms ensure that your conversation remains
                  private. Compliance with industry standard security measures
                  makes Biond safe for use.
                </p>
                <div className="microfeatures">
                  <span className="microfeatures__item microfeatures__item--negative">
                    <svg
                      width="12"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <g opacity=".5" stroke="#FFF">
                          <path d="M3.5 5.1V3a2.5 2.5 0 1 1 5 0v2.1" />
                          <circle cx="6" cy="10" r="5.5" />
                        </g>
                        <circle stroke="#20B8B1" cx="6" cy="10" r="2" />
                      </g>
                    </svg>
                    <span>Encryption</span>
                  </span>
                  <span className="microfeatures__item microfeatures__item--negative">
                    <svg
                      width="15"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        stroke="#FFF"
                        fill="none"
                        fillRule="evenodd"
                        opacity=".5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M7.5 1C6.1 2.4 3.767 3.8.5 4.267c0 0 0 7.933 7 10.733 7-2.8 7-10.733 7-10.733C11.233 3.8 8.9 2.4 7.5 1zM7.5 15V1M1.344 8.5h12.312" />
                      </g>
                    </svg>
                    <span>Firewall</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section section--primary view-index__voice">
          <div className="wrapper">
            <div className="view-index__voice__layout">
              <div className="view-index__voice__layout__content">
                <h3 className="u-type--gamma u-type--primary u-spc-bottom--lrg">
                  Crystal clear voice
                </h3>
                <p className="u-type--zeta u-type--o50 u-spc-bottom--lrg">
                  You can always talk without disruptions thanks to the world
                  class voice quality.
                </p>
                <div className="microfeatures">
                  <span className="microfeatures__item">
                    <svg
                      width="16"
                      height="14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path
                          stroke="#22363F"
                          opacity=".3"
                          d="M2.5.5h11l2 4-7.5 9-7.5-9z"
                        />
                        <path d="M3.5 4.5h9" stroke="#20B8B1" />
                      </g>
                    </svg>
                    <span>HQ OPUS Codec</span>
                  </span>
                  <span className="microfeatures__item">
                    <svg
                      width="11"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <g opacity=".3" stroke="#22363F">
                          <path d="M6.5.5h3" />
                          <rect x=".5" y="2.5" width="10" height="13" rx="1" />
                        </g>
                        <g stroke="#20B8B1">
                          <path d="M5.5 6.5v5M3.5 8.5v1M7.5 7.5v3" />
                        </g>
                      </g>
                    </svg>
                    <span>48kHz sampling</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="view-index__voice__layout__visual">
            <img alt="Voice" src={images.illustrationWave} />
          </div>
          <div className="view-index__messaging">
            <div className="wrapper">
              <div className="view-index__messaging__layout">
                <div className="view-index__messaging__layout__content">
                  <h3 className="u-type--gamma u-type--primary u-spc-bottom--lrg">
                    Messaging
                  </h3>
                  <p className="u-type--zeta u-type--o70 u-spc-bottom--lrg">
                    Fast and free chat in real-time or simply send SMS.
                  </p>
                  <div className="microfeatures">
                    <span className="microfeatures__item">
                      <svg
                        width="17"
                        height="16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3v4l4.667-4H15a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                          stroke="#22363F"
                          fill="none"
                          fillRule="evenodd"
                          opacity=".3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>IM</span>
                    </span>
                    <span className="microfeatures__item">
                      <svg
                        width="16"
                        height="14"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          fill="none"
                          fillRule="evenodd"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <g opacity=".3" stroke="#22363F">
                            <circle cx="5.5" cy="3.5" r="3" />
                            <path d="M5.5 8.5a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5z" />
                          </g>
                          <g transform="translate(10 1)" stroke="#20B8B1">
                            <circle cx="2.5" cy="2.5" r="2" />
                            <path d="M.841 7A3 3 0 0 1 5.5 9.5v1h-3" />
                          </g>
                        </g>
                      </svg>
                      <span>Group messaging</span>
                    </span>
                    <span className="microfeatures__item">
                      <svg
                        width="16"
                        height="16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          fill="none"
                          fillRule="evenodd"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path
                            d="M6.5 12.5h3l3 3v-3h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-1"
                            stroke="#20B8B1"
                          />
                          <path
                            d="M10.5.5h-9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2v3l3-3h4a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z"
                            opacity=".3"
                            stroke="#22363F"
                          />
                        </g>
                      </svg>
                      <span>SMS</span>
                    </span>
                  </div>
                </div>
                <div className="view-index__messaging__layout__visual">
                  <img alt="Messaging" src={images.illustrationMessagingAlt} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section section--primary section--darker view-index__quality">
          <div className="wrapper">
            <div className="view-index__quality__layout">
              <div className="view-index__quality__layout__content">
                <h3 className="u-type--gamma u-type--negative u-spc-bottom--lrg">
                  High quality audio and video, you name it
                </h3>
                <p className="u-type--negative u-type--o70 u-spc-bottom--lrg">
                  High quality Video and Voice calling for optimal user
                  experience
                </p>
                <div className="microfeatures">
                  <span className="microfeatures__item microfeatures__item--negative">
                    <svg
                      width="16"
                      height="14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        opacity=".5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path
                          d="M3.5.5h-1a2 2 0 0 0-2 2v11h5.05a2.5 2.5 0 0 1 4.9 0h5.05v-11a2 2 0 0 0-2-2h-1"
                          stroke="#FFF"
                        />
                        <path d="M3 8h11" stroke="#20B8B1" />
                      </g>
                    </svg>
                    <span>128 kbps</span>
                  </span>
                </div>
              </div>
              <div className="view-index__quality__layout__visual">
                <div className="view-index__quality__layout__visual--mark">
                  <img alt="Video" src={images.illustrationPhoneMark} />
                </div>
                <div className="view-index__quality__layout__visual--woman">
                  <img alt="Voice" src={images.illustrationPhoneWoman} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section section--primary view-index__sharing">
          <div className="wrapper">
            <div className="view-index__sharing__layout">
              <div className="view-index__sharing__layout__visual">
                <img alt="Sharing" src={images.illustrationFolder} />
              </div>
              <div className="view-index__sharing__layout__content">
                <h3 className="u-type--gamma u-type--primary u-spc-bottom--lrg">
                  Share anything
                </h3>
                <p className="u-type--zeta u-type--o70 u-spc-bottom--lrg">
                  Use rich file sharing features that include file, photo and
                  video formats.
                </p>
                <div className="microfeatures">
                  <span className="microfeatures__item">
                    <svg
                      width="14"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        stroke="#000"
                        fill="none"
                        fillRule="evenodd"
                        opacity=".3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M8.5 15.5h-8V.5h13v10z" />
                        <path d="M8.5 15.5v-5h5M3.5 4.5h7M3.5 7.5h7M3.5 10.5h2" />
                      </g>
                    </svg>
                    <svg
                      width="16"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd" opacity=".3">
                        <path
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M.5 12.5l4-4 3 3 4-5 4 4"
                        />
                        <path
                          d="M14.5 15.5h-13a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1z"
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          fill="#444"
                          fillRule="nonzero"
                          cx="6.5"
                          cy="4.5"
                          r="1.5"
                        />
                      </g>
                    </svg>
                    <svg
                      width="16"
                      height="12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        stroke="#000"
                        fill="none"
                        fillRule="evenodd"
                        opacity=".3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3.5 3.5h2M10.5 4.5v-3a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3l5 2v-7l-5 2z" />
                      </g>
                    </svg>
                    <svg
                      width="16"
                      height="14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        stroke="#000"
                        fill="none"
                        fillRule="evenodd"
                        opacity=".3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M.5.5h15v3H.5zM13.5 5.5v8h-11v-8" />
                        <path d="M5.5 6.5h5v3h-5z" />
                      </g>
                    </svg>
                    <span>File sharing</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section section--primary cta">
          <div className="wrapper">
            <div className="cta__layout">
              <div className="cta__layout__content">
                <h3 className="u-type--gamma u-type--primary u-spc-bottom--xlrg">
                  Not convinced? Give us a ring!
                </h3>
                <p className="u-type--zeta u-type--o70 u-spc-bottom--lrg">
                  For more info and support get in touch with a Biond support
                  expert.
                </p>
                <Link
                  to={contactRoute}
                  className="btn btn--secondary btn--med u-rounded"
                >
                  Get in touch
                </Link>
              </div>
              <div className="cta__layout__visual">
                <img alt="Support" src={images.illustrationContactPhone} />
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { singlePage } = state.pages;

  return {
    singlePage
  };
};

export default connect(mapStateToProps)(Index);



// WEBPACK FOOTER //
// ./src/views/Index.jsx